import { BaseReducerState, Bill, Response } from '../../../services'
import { ActionTypes } from '../actions'

export interface DeleteAccountAPIResponse extends Response {
  data: Bill
}

export type DeleteAccountState = BaseReducerState & {
  data: Bill
}

const deleteAccountInitialState: DeleteAccountState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deleteAccount = (
  state: DeleteAccountState = deleteAccountInitialState,
  action: { type: string; res: any }
): DeleteAccountState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_ACCOUNT}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_ACCOUNT}_SUCCESS`: {
      const { success, data, message } = <DeleteAccountAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.DELETE_ACCOUNT}_FAILURE`:
      const res = <DeleteAccountAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.DELETE_ACCOUNT}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
